import clsx from "clsx";
import { Fragment, memo } from "react";

import { Button } from "@shared/ui/button";

import { STATIC_ROUTE_HREFS, STATIC_ROUTE_LABELS } from "../model/labels";
import { useBreadcrumbs } from "../model/use-breadcrumbs";
import type { BreadcrumbsProps } from "../types";

import s from "./breadcrumbs.module.scss";

export const Breadcrumbs = memo(({ className, items }: BreadcrumbsProps) => {
  const dynamicItems = useBreadcrumbs();
  const crumbs = items ?? dynamicItems ?? [];

  return (
    <nav aria-label="breadcrumb" className={clsx(s.root, className)}>
      <Button href="/" className={s.link}>
        Главная
      </Button>
      <span className={s.delimiter}>/</span>

      {Array.isArray(crumbs) &&
        crumbs.length > 0 &&
        crumbs.map((item) => {
          if (!STATIC_ROUTE_HREFS[item]) return null;
          return (
            <Fragment key={item}>
              <Button className={s.link} href={STATIC_ROUTE_HREFS[item]}>
                {STATIC_ROUTE_LABELS[item]}
              </Button>
              <span className={s.delimiter}>/</span>
            </Fragment>
          );
        })}
    </nav>
  );
});
